import { render } from "./TSMSubItemsPage.vue?vue&type=template&id=5c20cac3"
import script from "./TSMSubItemsPage.vue?vue&type=script&lang=js"
export * from "./TSMSubItemsPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__